import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PoAutoApprovalPageRoutingModule } from './po-auto-approval-routing.module';

import { PoAutoApprovalPage } from './po-auto-approval.page';
import { IonicSelectableModule } from 'ionic-selectable';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PoAutoApprovalPageRoutingModule,
    IonicSelectableModule,
    NgxDatatableModule
  ],
  declarations: [PoAutoApprovalPage]
})
export class PoAutoApprovalPageModule {}
